import { observable, syncedCrud } from '@/libs/state'
import type { NotifyPort } from '@/features/messages/domain/notify'
import type { Department, DepartmentPort, OrgTeam, OrgTeamPort } from '../domain/member'

// Secondary adapter: wraps DepartmentPort in a syncedCrud observable.
// Auto-fetches on first access. Depends only on the port interface - no PocketBase knowledge.
const makeSyncedDepartments = (port: DepartmentPort, notify: NotifyPort) =>
	observable(
		syncedCrud<Department, Department, 'array'>({
			list: () => port.listDepartments(),
			as: 'array',
			fieldId: 'id',
			initial: [],
			onError: (_err, { source }) => {
				if (source === 'list') notify.error('hr.departmentsLoadFailed')
			},
		}),
	)

// Secondary adapter: wraps OrgTeamPort in a syncedCrud observable.
const makeSyncedOrgTeams = (port: OrgTeamPort, notify: NotifyPort) =>
	observable(
		syncedCrud<OrgTeam, OrgTeam, 'array'>({
			list: () => port.listTeams(),
			as: 'array',
			fieldId: 'id',
			initial: [],
			onError: (_err, { source }) => {
				if (source === 'list') notify.error('hr.teamsLoadFailed')
			},
		}),
	)

export { makeSyncedDepartments, makeSyncedOrgTeams }
